import { MARKER_LAYOUT } from './cornerTurnLabel3d.js';
import { createCornerTurnLabel3d } from './cornerTurnLabel3d.js';
import { setCornerLabelContent } from './cornerLabel.js';

/**
 * @param {{
 *   cornerRingRadius: number;
 *   cornerBeamHeight: number;
 *   cornerLabelScale: number;
 * }} settings
 */
export function computeMarkerLabelOffsetY(settings) {
  const base = settings.cornerRingRadius * 1.4 + 0.1;
  const labelHeight =
    MARKER_LAYOUT.height * MARKER_LAYOUT.pxScale * settings.cornerLabelScale;
  return base + labelHeight * 0.55;
}

/**
 * @param {THREE.Group} marker
 * @param {string} name
 * @param {number} index
 * @param {{ labelScale: number; offsetY: number }} options
 */
export function attachMarkerLabel(marker, name, index, options) {
  disposeMarkerLabel(marker);

  const api = createCornerTurnLabel3d();
  setCornerLabelContent(api, name, index);
  api.setScale(options.labelScale);
  api.object.position.set(0, options.offsetY, 0);
  api.object.visible = false;
  marker.add(api.object);
  marker.userData.cornerLabel = api;
  return api.object;
}

/**
 * @param {THREE.Group} marker
 * @param {string} name
 * @param {number} index
 */
export function updateMarkerCornerLabel(marker, name, index) {
  const api = marker.userData.cornerLabel;
  if (!api) return;
  setCornerLabelContent(api, name, index);
}

/**
 * @param {THREE.Group} marker
 */
export function disposeMarkerLabel(marker) {
  const api = marker.userData.cornerLabel;
  if (!api) return;
  if (api.object.parent) {
    api.object.parent.remove(api.object);
  }
  api.dispose();
  delete marker.userData.cornerLabel;
}
